<lib-layout>
  <lib-header *libLayoutHeader></lib-header>
  <lib-navigation *libLayoutNavigation></lib-navigation>
  <router-outlet *libLayoutContent>
  </router-outlet>
  <lib-footer *libLayoutFooter></lib-footer>
</lib-layout>